import * as Api from '../api';

const api = process.env.REACT_APP_ONB_API;

export const getPronouns = Api.get({ path: '/api/v1/pronouns', api });
